<template>
  <div>
    <div class="top">
      <div class="main-width py-5">
        <VBreadcrumb
          :options="[{ label: '首页', to: '/' }, { label: cruiseInfo.name }]"
        ></VBreadcrumb>
      </div>
      <section class="main-width harbor">
        <img class="poster" v-if="cruiseInfo.image" :src="cruiseInfo.image" />
        <div class="text-div">
          <h1>{{ cruiseInfo.name }}</h1>
          <div class="relative">
            <div class="information" :class="{ active: infoExpand }">
              <div
                class="desc"
                ref="descRef"
                v-html="cruiseInfo.introduce"
              ></div>
              <div class="text-right pl-10" v-if="infoExpandVisiblity">
                <button v-if="!infoExpand" class="more" @click="toggleExpand">
                  查看更多<i class="el-icon-arrow-down"></i>
                </button>
                <button v-else class="more" @click="toggleExpand">
                  关闭更多<i class="el-icon-arrow-up"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="box">
      <div class="main-width">
        <div class="holday-filter">
          <div class="filter-row">
            <filter-bar
              name="邮轮公司"
              :options="filter.company"
              :is-all="queryData.brand.length == 0"
              @on-clear="handleClearQuery('brand')"
              v-if="filter.company && filter.company.length"
            >
              <template #item="{ option }">
                <v-checkbox
                  :val="option.id"
                  v-model="queryData.brand"
                  @change="handleFitlerChange"
                >
                  {{ option.name }}
                </v-checkbox>
              </template>
            </filter-bar>
            <filter-bar
              name="出游日期"
              :options="filter.months"
              :is-all="queryData.months.length == 0"
              @on-clear="handleClearQuery('months')"
              type="group"
              v-if="filter.months && filter.months.length"
            >
              <template #item="{ option }">
                <v-checkbox
                  :val="option.value"
                  v-model="queryData.months"
                  @change="handleFitlerChange"
                >
                  {{ option.name }}
                </v-checkbox>
              </template>
            </filter-bar>
            <filter-bar
              name="出发城市"
              :options="filter.cruise_ports"
              :is-all="queryData.city.length == 0"
              @on-clear="handleClearQuery('city')"
              v-if="filter.cruise_ports && filter.cruise_ports.length"
            >
              <template #item="{ option }">
                <v-checkbox
                  :val="option.key"
                  v-model="queryData.city"
                  @change="handleFitlerChange"
                >
                  {{ option.title }}
                </v-checkbox>
              </template>
            </filter-bar>
            <filter-bar
              name="出游天数"
              :options="filter.travel_days"
              :is-all="queryData.days.length == 0"
              @on-clear="handleClearQuery('days')"
              v-if="filter.travel_days && filter.travel_days.length"
            >
              <template #item="{ option }">
                <v-checkbox
                  :val="option.val"
                  v-model="queryData.days"
                  @change="handleFitlerChange"
                >
                  {{ option.value }}
                </v-checkbox>
              </template>
            </filter-bar>
          </div>
        </div>
        <product-list
          :listData="listData"
          :loading="loading"
          @change="listQueryChange"
          :initSort="[queryData.sort_name]"
          :initSortType="queryData.sort_type"
          :pageIndex="queryData.page_index"
        ></product-list>
      </div>
    </section>
    <AppDock />
  </div>
</template>

<script>
import { defineComponent, useMeta, toRaw } from "@nuxtjs/composition-api";
import FilterBar from "@/components/product/filterBar";
import ProductList from "@/components/product/productList.vue";
import calcTextLine from "@/utils/calcTextLine";
import { getDestFilter, getDestList } from "@/services/destination";
import VBreadcrumb from "@/components/VBreadcrumb.vue";
import AppDock from "~/components/layouts/AppDock.vue";

export default defineComponent({
  name: "destinationList",
  auth: false,
  head: {},
  layout: "Main",
  components: { FilterBar, ProductList, VBreadcrumb, AppDock },
  setup() {
    useMeta(() => ({
      title: "邮轮目的地",
    }));
  },
  data() {
    return {
      infoExpand: false,
      infoExpandVisiblity: false,
      listData: {},
      loading: false,
      filter: {},
      cruiseInfo: {},
      queryData: {
        route_id: null,
        brand: [],
        months: [],
        city: [],
        days: [],
        sort_type: "",
        sort_name: "1",
        page_index: 1,
        page_size: 10,
      },
    };
  },
  methods: {
    toggleExpand() {
      if (this.infoExpand) {
        this.$refs.descRef.scrollTop = 0;
      }
      this.infoExpand = !this.infoExpand;
    },
    formatDateGroup(dates) {
      let res = [];
      if (!dates) {
        return [];
      }
      for (let i = 0; i < dates.length; i++) {
        let obj = {};
        const key = dates[i].year;
        obj.group = key + "年";
        obj.value = dates[i].months;
        res.push(obj);
      }
      return res;
    },
    formatDays(days) {
      let res = [...days];
      for (let i = 0; i < res.length; i++) {
        res[i]["val"] = {
          min: res[i]["gte"],
          max: res[i]["lte"],
        };
      }
      return res;
    },
    handleClearQuery(key) {
      this.queryData[key] = [];
      this.$nextTick(this.handleFitlerChange);
    },
    handleFitlerChange() {
      this.queryData.page_index = 1;
      this.getLists(this.queryData);
    },
    listQueryChange(val) {
      this.queryData.page_index = val.page_index;
      this.queryData.page_size = val.page_size;
      this.queryData.sort_name = val.sort_name;
      this.queryData.sort_type = val.sort_type;

      this.getLists(this.queryData);
    },
    async getLists(params) {
      console.log("ppp", params);
      this.$router.replace({
        query: toRaw(params),
      });
      this.loading = true;
      const { data, code, msg } = await getDestList(params);
      console.log("list data", data);
      this.loading = false;
      if (code === 10000 || code === 200) {
        this.listData = data;
      } else {
        this.$message({
          type: "error",
          text: msg,
        });
      }
    },
    async getData() {
      const { query } = this.$route;
      if (query.page_index) {
        query.page_index = Number(query.page_index);
      }
      if (query.page_size) {
        query.page_size = Number(query.page_size);
      }
      this.queryData = { ...this.queryData, ...query };

      await this.getLists(this.queryData);
      const { code, msg, data } = await getDestFilter({
        route_id: query.route_id,
      });
      if (code === 10000 || code === 200) {
        this.filter = {
          months: this.formatDateGroup(data.filter.year_month),
          company: data.filter.company,
          cruise_ports: data.filter.cruise_ports,
          travel_days: this.formatDays(data.filter.travel_days),
        };
        this.cruiseInfo = {
          image: data.image,
          introduce: data.introduce,
          name: data.name,
        };
      } else {
        this.$message({
          type: "error",
          text: msg,
        });
      }
      this.$nextTick(() => {
        let line = calcTextLine(this.$refs.descRef);
        if (line > 2) {
          this.infoExpandVisiblity = true;
        } else {
          this.infoExpandVisiblity = false;
        }
      });
    },
  },
  mounted() {
    let line = calcTextLine(this.$refs.descRef);
    if (line > 2) {
      this.infoExpandVisiblity = true;
    } else {
      this.infoExpandVisiblity = false;
    }
  },
  async fetch() {
    await this.getData();
  },
  watch: {
    $route: async function (val, oldVal) {
      console.log(val);
      if (
        val.path == oldVal.path &&
        val.query.route_id == oldVal.query.route_id
      ) {
        return;
      }
      this.queryData = {
        route_id: null,
        brand: [],
        months: [],
        sort_type: "",
        sort_name: "1",
        page_index: 1,
        page_size: 10,
      };
      this.infoExpand = false;
      this.infoExpandVisiblity = false;

      await this.getData();
    },
  },
});
</script>

<style lang="scss" scoped>
.harbor .text-div .information.active .desc {
  display: block;
  max-height: 508px;
  overflow-y: auto;
  width: auto;
  margin-bottom: 15px;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
}
.top {
  padding-bottom: 40px;
  width: 100%;
  background-color: #fff;
}
.harbor {
  position: relative;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 320px;
}
.harbor .poster {
  width: 100%;
  height: 320px;
  object-fit: cover;
  border-radius: 4px;
}
.harbor .text-div {
  width: 100%;
  height: 231px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.8) 100%
      );
  padding: 90px 0px 28px 0px;
  border-radius: 0 0 4px 4px;
}
.harbor .text-div h1 {
  font-size: 52px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 1;
  padding-left: 30px;
}
.harbor .text-div .information {
  max-height: 200px;
  display: flex;
  align-items: flex-end;
  padding: 0 42px 0 30px;
}
.harbor .text-div .information .desc {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #fff;
  font-size: 16px;
  white-space: pre-line;
}
.harbor .text-div .information .more {
  width: 95px;
  height: 28px;
  font-size: 14px;
  border: 1px solid #fff;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 14px;
}
.harbor .text-div .information .more i {
  margin-top: 2px;
}
.harbor .text-div .information .more:hover {
  color: $color-primary;
  border-color: $color-primary;
}
.harbor .text-div .information.active {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  padding: 34px 39px 25px 39px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #d4d7de;
  background-color: #fff;
  max-height: 576px;
  display: block;
}
.harbor .text-div .information.active .more {
  border-color: #191919;
  background-color: #fff;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.harbor .text-div .information.active .more i {
  margin-top: 0;
}
.harbor .text-div .information.active .more:hover {
  color: $color-primary;
  border-color: $color-primary;
}
.box {
  background-color: #fff;
  padding-bottom: 98px;
}
.holday-filter {
  background: linear-gradient(180deg, #f3f5f8 0%, rgba(255, 255, 255, 0) 100%);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px 20px 0 0;
}
.holday-filter .filter-row {
  padding: 20px 28px;
}
</style>
